import {useState} from "react"
import {Upload} from "antd"
import {Icon} from "components/Icon"
import {useModel, useVisible} from "hooks"
import {ConfirmPopup} from "uiKit"
import {taskService} from "services"
import {useMutation} from "@tanstack/react-query"
import {handleError} from "helpers"
import styles from "./EditTaskDocument.module.css"

export function EditTaskDocument({taskData, onSuccess}: {taskData: any; onSuccess: () => void}) {
    const model = useModel()
    const confirmPopup = useVisible(false)
    const [activeFile, setActiveFile] = useState(null)
    const allowedDocumentFormats = model.getAllowedDocumentFormats() || "application/pdf"

    const updateDigitalDocument = useMutation((data: any) => taskService.updateDDDocument(data), {
        onSuccess: () => {
            confirmPopup.close()
            onSuccess()
        },
        onError: (error) => handleError(error)
    })

    const handleChangeFile = (file) => {
        confirmPopup.open()
        setActiveFile(file)
        return false
    }

    const handleConfirm = () => {
        const formData = new FormData()
        formData.append("taskId", taskData.id)
        formData.append("file", activeFile)
        updateDigitalDocument.mutate(formData)
    }

    return (
        <div className={styles.wrap}>
            <p className={styles.title}>Update new document</p>
            <div className={styles.uploadIconWrap}>
                <Upload beforeUpload={handleChangeFile} accept={allowedDocumentFormats}>
                    <Icon icon="UPLOAD" color="#FF349B" />
                </Upload>
            </div>
            <ConfirmPopup
                isVisible={confirmPopup.isVisible}
                title="This action can't be reversed. Are you sure want to update digital document file?"
                onClose={confirmPopup.close}
                loading={updateDigitalDocument.isLoading}
                onConfirm={handleConfirm}
            />
        </div>
    )
}
